import { render } from "./viaturaView.vue?vue&type=template&id=57fc9022"
import script from "./viaturaView.vue?vue&type=script&lang=js"
export * from "./viaturaView.vue?vue&type=script&lang=js"

import "./viaturaView.vue?vue&type=style&index=0&id=57fc9022&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__